import { useState, useEffect } from 'react'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || ''

/**
 * Check whether RSVP submissions are still open for an invitation.
 * Returns true (open) if the request fails, to avoid blocking guests on network errors.
 */
export async function fetchRsvpOpen(invitationId) {
  try {
    const res = await fetch(`${API_BASE_URL}/rsvp/status/${encodeURIComponent(invitationId)}`)
    const json = await res.json().catch(() => ({}))
    return json.open !== false
  } catch {
    return true
  }
}

/**
 * Hook for use in any invitation design component.
 * Automatically checks RSVP status on mount.
 *
 * Usage:
 *   const rsvpOpen = useRsvpOpen('your-invitation-id')
 *
 * Returns true while loading (safe default — avoids hiding form on slow connections).
 */
export function useRsvpOpen(invitationId) {
  const [open, setOpen] = useState(true)

  useEffect(() => {
    if (!invitationId) return
    fetchRsvpOpen(invitationId).then(setOpen)
  }, [invitationId])

  return open
}
